<template>
  <p class="component-hint-text">
    <i class="icon-exclamation text-info text-lg"></i>
    {{ value }}
  </p>
</template>

<script>

export default {
  name: 'HintField',

  components: { },

  props: {
    value: {
      type: String,
      default: '',
    },
  },
  mounted() {},

}
</script>

